import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import LoanCalculator from "./components/LoanCalculator";
import ModelsSection from "./components/ModelsSection";
import ColorsSection from "./components/ColorsSection";
import BenefitsSection from "./components/BenefitsSection";
import TestimonialsSection from "./components/TestimonialsSection";
import CustomerGallery from "./components/CustomerGallery";
import QASection from "./components/QASection";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import AdminDashboard from "./components/AdminDashboard";
import AdminAnalytics from "./components/AdminAnalytics";
import SEOHead from "./components/SEOHead";
import WelcomeModal from "./components/WelcomeModal";
import StickyQuoteButton from "./components/StickyQuoteButton";
import SharedCalculation from "./components/SharedCalculation";
import AIChatbot from "./components/AIChatbot";
import BrochureCenter from "./components/BrochureCenter";
import RebateSection from "./components/RebateSection";
import RebatePage from "./components/RebatePage";
import EligibilityCalculator from "./components/EligibilityCalculator";
import { Toaster } from "./components/ui/sonner";
import { initializeAnalytics, analytics } from "./utils/analytics";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view to internal analytics
    analytics.trackPageView('Home - Syasyah Perodua');
    
    // Track page view to Google Analytics
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'page_view', {
        page_title: 'Home - Syasyah Perodua',
        page_location: window.location.href,
        event_category: 'navigation'
      });
    }
  }, []);

  // Auto-scroll to specific section based on URL path
  useEffect(() => {
    const scrollToSection = () => {
      const path = location.pathname;
      let sectionId = '';

      switch (path) {
        case '/models':
          sectionId = 'models';
          break;
        case '/calculator':
          sectionId = 'calculator';
          break;
        case '/benefits':
          sectionId = 'benefits';
          break;
        case '/contact':
          sectionId = 'contact';
          break;
        case '/colors':
          sectionId = 'colors';
          break;
        case '/testimonials':
          sectionId = 'testimonials';
          break;
        case '/faq':
          sectionId = 'qa';
          break;
        default:
          sectionId = '';
      }

      if (sectionId) {
        // Wait for page to load, then scroll
        setTimeout(() => {
          const element = document.getElementById(sectionId);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);
      } else {
        // Scroll to top for home page
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    };

    scrollToSection();
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-white">
      <WelcomeModal />
      <Header />
      <main>
        <HeroSection />
        <RebateSection />
        <LoanCalculator />
        <ModelsSection />
        <ColorsSection />
        <BenefitsSection />
        <CustomerGallery />
        <TestimonialsSection />
        <QASection />
        <ContactForm />
      </main>
      <Footer />
      <AIChatbot />
      <Toaster />
    </div>
  );
};

function App() {
  useEffect(() => {
    // Initialize analytics tracking
    initializeAnalytics();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <SEOHead />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/models" element={<Home />} />
          <Route path="/calculator" element={<Home />} />
          <Route path="/calculator/shared/:calcId" element={<SharedCalculation />} />
          <Route path="/benefits" element={<Home />} />
          <Route path="/contact" element={<Home />} />
          <Route path="/colors" element={<Home />} />
          <Route path="/testimonials" element={<Home />} />
          <Route path="/faq" element={<Home />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/analytics" element={<AdminAnalytics />} />
          <Route path="/brochure" element={<BrochureCenter />} />
          <Route path="/rebate" element={<RebatePage />} />
          <Route path="/calculator-kelayakan" element={<EligibilityCalculator />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;